import { przezmorzeApi, throwMessageOnBadRequestStatus } from "../../../api/api";
import type { AddOrderNoteRequest, Note, OrderNotesListResponse } from "@przezmorze/api-types";

export type { AddOrderNoteRequest, Note };

export async function getOrderNotes(orderId: string, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<OrderNotesListResponse>(`/orders/${orderId}/notes`, { signal: abortSignal });
  return response.data.items;
}

export async function addOrderNote(orderId: string, request: AddOrderNoteRequest, abortSignal?: AbortSignal) {
  try {
    const response = await przezmorzeApi.post<OrderNotesListResponse>(`/orders/${orderId}/notes`, request, {
      signal: abortSignal,
    });
    return response.data.items;
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}
